import { CircularProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useGetEvaluationQuery } from "../../redux/api/evaluation";
import EvaluationForm from "./EvaluationForm";
import UnlicensedEvaluationForm from "./UnlicensedEvaluationForm";
import { useEffect } from "react";

/**
 * EvaluationRouter
 *
 * This component is routed to by /evaluations/:id.
 * It loads the evaluation and determines which form to render based on the rating.
 * - Senior Officer: Master, CE, CM, 1AE → EvaluationForm
 * - Junior Officer: 2AE, 3AE, 2M, 3M → JuniorEvaluationForm (to be implemented)
 * - All others → UnlicensedEvaluationForm
 */

const EvaluationRouter = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: evaluation, isLoading, isError } = useGetEvaluationQuery(id ?? "", {
    skip: !id,
  });

  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError, navigate]);

  if (isLoading || !evaluation) {
    return <CircularProgress />;
  }

  // Determine rating from evaluation or profile fallback
  const formName = evaluation?.form?.name || "";


  if (formName === 'Senior Officers') {
    return <EvaluationForm />;
  }

  if (formName === 'Junior Officers') {
    // Placeholder until JuniorEvaluationForm is implemented
    return <EvaluationForm juniorOfficer/>;
  }

  return <UnlicensedEvaluationForm />;
};

export default EvaluationRouter;
